export default __webpack_public_path__ + "static/media/raspas.ee6902e1.png";